const validOverrideClassKeys = {
  'btn-primary': true,
};

export default validOverrideClassKeys;
